<mat-icon #actionsIcon class="icon" (click)="onActionsIconClicked()" (shrClickOutside)="onClickOutside()">more_vert</mat-icon>
<ng-template #popOutOverlayTemplate>
    <div [@slideInOut] (@slideInOut.start)="animStart($event)" (@slideInOut.done)="animEnd($event)"
        class="overlay mat-elevation-z8" fxLayout="row" fxLayoutAlign="start center">
        <ng-content></ng-content>
    </div>
</ng-template>
